import { Component, OnInit } from '@angular/core';
import {TiendaService} from "../Services/tienda.service";
import {Tienda} from "../tienda/tienda";
import {Message} from "primeng/primeng";
import {FacturaService} from "../Services/factura.service";

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

  msgs: Message[] = [];
  options: any;
  loading = false;
  TiendasRegistrados:Tienda[];
  ventasByTienda:any[];
  TotalVentas = 0;
  totalSeparados = 0;
  fInicial;
  fFinal;
  tiendaSeleccionada = Tienda;
  verDetalles= false;

  constructor(private servicioFactura:FacturaService,private servicioTienda:TiendaService) {

  }

  ngOnInit() {
    this.listarTiendas();
  }

  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          console.log(this.TiendasRegistrados);
          this.TotalVentas = 0;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  enviarTienda(dato){
    this.loading = true;
    this.TotalVentas = 0;
    this.totalSeparados = 0;
    this.servicioTienda.getVentasByTienda(dato.tienda.id)
      .subscribe(
        rt => {
          this.ventasByTienda = rt;
          for(let item of this.ventasByTienda){
            this.TotalVentas += parseInt(item.total);
          }

          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );

    this.servicioTienda.getSeparadosByTienda(dato.tienda.id)
      .subscribe(
        rt => {
          for(let item of rt){
            this.totalSeparados += parseInt(item.total) - parseInt(item.saldo);
          }

          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  /*SeleccionarTienda(item){
    this.tiendaSeleccionada = item.tienda;

    this.verDetalles = true;
  }
  ListarFacturaTienda(){
    this.loading = true;
    let obj = new Object();
    obj['fechaInicial'] = this.fInicial;
    obj['fechaFinal'] =this.fFinal;
    obj['tienda_id'] = this.tiendaSeleccionada['id'];
    this.TotalVentas = 0;
    this.servicioFactura.getFacturaByFecha(obj)
      .subscribe(
        rt => {
          for(let item of rt){
            this.TotalVentas += parseInt(item.total);
          }

        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }*/
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/inicio/inicio.component.ts